import React from 'react';

import styles from '../../css/Spinner.module.css';

const Spinner = () => {
  return <div className={styles.loader} />;
};

export default Spinner;
